import { parse } from "query-string";
import { useLocation } from "react-router";

export const useFilterTypeFromParams = (filtrationTypes) => {
	const { search } = useLocation();
	const params = parse(search);

	const findedType = filtrationTypes.find((type) => type.key === params.sort) || filtrationTypes[0];

	return [findedType];
};
